/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Keywords_MissingInputs */

const en_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const de_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const fr_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const es_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const it_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const nl_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const pl_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const fi_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const da_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const sv_deep_match_keywords_missing = /** @type {(inputs: Deep_Match_Keywords_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

/**
* | output |
* | --- |
* | "Missing" |
*
* @param {Deep_Match_Keywords_MissingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_keywords_missing = /** @type {((inputs?: Deep_Match_Keywords_MissingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Keywords_MissingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_keywords_missing(inputs)
	if (locale === "fr") return fr_deep_match_keywords_missing(inputs)
	if (locale === "es") return es_deep_match_keywords_missing(inputs)
	if (locale === "it") return it_deep_match_keywords_missing(inputs)
	if (locale === "nl") return nl_deep_match_keywords_missing(inputs)
	if (locale === "pl") return pl_deep_match_keywords_missing(inputs)
	if (locale === "fi") return fi_deep_match_keywords_missing(inputs)
	if (locale === "da") return da_deep_match_keywords_missing(inputs)
	if (locale === "sv") return sv_deep_match_keywords_missing(inputs)
	return en_deep_match_keywords_missing(inputs)
});